"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifiedInformationFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.verifiedInformationFactory = Factory.Sync.makeFactory({
    org_id: mocks_1.orgNgb.id,
    root_org_id: null,
    persona_id: mocks_1.persona.id,
    verified: true,
    first_name: mocks_1.persona.first_name,
    last_name: mocks_1.persona.last_name,
    middle_name: 'Jon',
    suffix: 'Jr.',
    gender: mocks_1.persona.gender,
    date_of_birth: mocks_1.persona.date_of_birth,
    graduation_year: 2030,
    approved_at: mocks_1.dates.date2000,
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
});
